import { getItemsFromCollection } from "directus/src/operations";

export async function fetchDiscordForProject({ id }) {
  try {
    const query = {
      fields: [
        "id",
        "item:integrations_discord.id",
        "item:integrations_discord.channel_id",

        "collection",
      ],
      filter: {
        projects: {
          _eq: id,
        },
        collection: {
          _eq: "integrations_discord",
        },
      },
    };
    const response = await getItemsFromCollection("projects__integrations", query);
    return response;
  } catch (error) {
    console.error(error);
    throw error;
  }
}

export async function fetchDriveForProject({ id }) {
  try {
    const query = {
      fields: [
        "id",
        "item:integrations_drive.id",
        "item:integrations_drive.folder_id",

      ],
      filter: {
        projects: {
          _eq: id,
        },
        collection: {
          _eq: "integrations_drive",
        },
      },
    };
    const response = await getItemsFromCollection("projects__integrations", query);
    return response;
  } catch (error) {
    console.error(error);
    throw error;
  }
}

export async function fetchGithubForProject({ id }) {
  try {
    const query = {
      fields: [
        "id",
        "item:integrations_github.id",
        "item:integrations_github.repository_url",

        "item:integrations_github.suffix",

      ],
      filter: {
        projects: {
          _eq: id,
        },
        collection: {
          _eq: "integrations_github",
        },
      },
    };
    const response = await getItemsFromCollection("projects__integrations", query);
    return response;
  } catch (error) {
    console.error(error);
    throw error;
  }
}
